import Select, { OptionWithFederalSubject } from "components/shared/select";
import React from "react";
import { getRegionsByName } from "sources/map";

const styles = (content) => ({
    control: (styles) => ({
        ...styles,
        width: "250px",
        minHeight: "30.5px",
        fontSize: "14px",
        "&:hover": {
            zIndex: 1,
        },
        "@media only screen and (max-width: 769px)": {
            width: "100%",
        },
    }),
    menu: (styles) => ({
        ...styles,
        zIndex: 4,
    }),
    option: (styles) => ({ ...styles, fontSize: "14px" }),
    valueContainer: (styles) => ({
        ...styles,
        lineHeight: "18px",
        paddingLeft: "29px",
        position: "relative",
        "&:before": {
            fontSize: "10px",
            fontWeight: "600",
            lineHeight: "13px",
            content: `'${content}'`,
            position: "absolute",
            left: "7px",
            display: "block",
            borderRadius: "50%",
            border: "1px solid",
            width: "15px",
            height: "15px",
            textAlign: "center",
        },
    }),
    indicatorsContainer: (styles) => ({ ...styles, height: "30px" }),
    dropdownIndicator: (styles) => ({ ...styles, padding: "4px", display: "none" }),
    indicatorSeparator: () => ({ display: "none" }),
    placeholder: (styles) => ({ ...styles, lineHeight: "18px" }),
});

const config = {
    firstPointConfig: {
        placeholder: "Откуда",
        inputProps: { name: "firstPoint" },
        url: getRegionsByName,
        propName: "name",
        isMulti: false,
        minimumInputLength: 2,
        styles: styles("A"),
        components: { Option: OptionWithFederalSubject },
    },
    lastPointConfig: {
        placeholder: "Куда",
        inputProps: { name: "lastPoint" },
        url: getRegionsByName,
        propName: "name",
        isMulti: false,
        minimumInputLength: 2,
        styles: styles("B"),
        components: { Option: OptionWithFederalSubject },
    },
};

const renderSelect = (propName, props) => {
    const defProps = {
        value: props.values[propName] ? props.values[propName].id : null,
        onChange: ({ name, value, option }) =>
            props.setFilter({ name, value: value ? { id: value, type: option.type } : null }),
    };
    return <Select {...config[`${propName}Config`]} {...defProps} />;
};

const PointsFilter = (props) => {
    return (
        <>
            <div className="mb-md-0 report__filters--mr">{renderSelect("firstPoint", props)}</div>
            <div className="mb-md-0 report__filters--mr">{renderSelect("lastPoint", props)}</div>
        </>
    );
};

export default PointsFilter;
